import { createFileRoute } from '@tanstack/react-router'

import { BackofficeHomePage } from '../../components/pages/backoffice/home/backoffice-home-page.tsx'

export const Route = createFileRoute('/bo/')({
  component: BackofficeHomePage,
})
